import React, { useState, useEffect } from "react"
import { Row, Col, Container, Button } from "reactstrap"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Modal from "../../components/RopikCustom/Modal";

import moment from "moment";
import { getCompanyOrder, getPaymentList, postPaymentLog, postPaymentReport, postTax } from "crud/auth.crud";

import Util from "pages/Dashboard/Common/Util";
import { useHistory } from "react-router-dom";

import loading from "../../assets/images/loading.gif";

const style = { backgroundColor: "#ffffff", padding: "0.5rem", cursor: "pointer", width: '466px', border: '1px solid #bdbdbd', marginTop : '0.5rem', borderRadius: '4px', color : '#333'  };

const hoverStyle = { backgroundColor: "#4DBBAA", color: "#ffffff", width: '466px', border: '1px solid #4DBBAA' };

const EmitterBill = props => {
  const selector = useSelector(state => state)
  const newDate = new Date()
  const nextDate = new Date()
  const preDate = new Date()
  const preMonth = new Date()
  const history = useHistory()
  const { IMP } = window

  const [isLoading, setIsLoading] = useState(true);
  const [prevSumData, setPrevSumData] = useState(0);
  const [sumData, setSumData] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [payMethod, setPayMethod] = useState();
  const [data, setData] = useState([]);
  const [priceObj, setPriceObj] = useState({});
  const [price, setPrice] = useState(0);
  const [pricePerL, setPricePerL] = useState(170);
  const [company, setCompany] = useState(selector.auth?.user?.member_group?.[0]?.company_group);
  const [companyId, setCompanyId] = useState(selector.auth?.user?.member_group?.[0]?.company_group.id);
  const [totalElements, setTotalElements] = useState(0);
  const [page, setPage] = useState(1);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isListEnd, setIsListEnd] = useState(false);
  const [checkedDateType, setCheckedDateType] = useState('');
  const [yearModalShow, setYearModalShow] = useState(false);
  const [monthModalShow, setMonthModalShow] = useState(false);
  const [prevMonth, setPrevMonth] = useState(moment(preMonth).format('DD') > 10 ? moment(preMonth).format('MM') : moment(preMonth.setMonth(preMonth.getMonth()-1)).format('MM'));
  const [prevDate, setPrevDate] = useState(moment(preDate).format('DD') > 10 ? moment(preDate.setMonth(preDate.getMonth()+1)).format('MM') + '/10' : moment(preDate).format('MM') + '/10');
  const [startDate, setStartDate] = useState(moment(newDate).format('YYYY-MM') + '-01 00:00:00');
  const [endDate, setEndDate] = useState(moment(nextDate).format('YYYY-MM') + '-01 00:00:00');
  const [companyTo, setCompanyTo] = useState('');
  const [modalSuccess, setModalSuccess] = useState(false);
  const [order, setOrder] = useState({});
  const [rsp, setRsp] = useState();
  const [isHover, setIsHover] = useState()
  const [selectedData, setSelectedData] = useState({})

  const payMethodArr = [
    { 'key' : 'card', 'text' : '신용카드'},
    { 'key' : 'trans', 'text' : '계좌이체'},   
    { 'key' : 'phone', 'text' : '휴대폰결제'},         
  ]

  const getDataList = async () => {
    let url = '/payment_report/get_payment_all_collect_report/?company='
    try {
      const params = {
        company: companyId,
        // date: '2022-07-01 00:00:00',
        date: startDate
      }
      const response = await getPaymentList(url, params);
      if (response.data?.result === 'success') {
        setData([...response?.data?.data] || [])
      }
      setIsLoading(false)
    } catch (error) {
      console.error(error);
    }
  }

  const requestPay = () => {
    IMP.init("imp41866208")
    IMP.request_pay({
      pg: 'nice',
      pay_method: payMethod || 'card',
      currency: undefined,
      notice_url: undefined,
      display: undefined,
      merchant_uid: `mid_${new Date().getTime()}`,
      name: company.name + ' ' + prevDate,
      //amount : data.price || 0,
      amount : 1000,
      app_scheme: 'wasteverse',
      tax_free: undefined,
      buyer_name: company.name || '회사명',
      buyer_tel: company.mobile_phone || '회사모바일번호',
      buyer_email: company.email || '회사이메일',
      buyer_addr: undefined,
      buyer_postcode: undefined,
      custom_data: undefined,
      vbank_due: undefined,
      digital: false,
      language: undefined,
      biz_num: undefined,
      customer_uid: undefined,
      naverPopupMode: undefined,
      naverUseCfm: undefined,
      naverProducts: undefined,
      m_redirect_url: undefined,
      niceMobileV2: true,
      escrow : false,
    }, function (response) { // callback
      setRsp(response)
      if (response.success) {
        savePaymentLog('Y', response)
        savePayment(response)
        setModalSuccess(true)
      } else {
        savePaymentLog('N', response)
        alert("결제에 실패하였습니다. \n에러내용: " + response.error_msg)
      }
    });
  }
  
  const savePaymentLog = async (state, response) => {
    const params = {
      company_from: order?.companyFrom,
      company_to: order?.companyTo,
      payment_report: order?.paymentReportId,
      payment_type: 'card',
      imp_uid: response?.imp_uid,
      merchant_uid: response.merchant_uid,
      price: order?.totalPrice,
      status: state
    }
    const rs = await postPaymentLog(params);
  }

  const savePayment = async (response) => {
    setIsLoading(true)
    const params = {
      company_from: order?.companyFrom,
      company_to: order?.companyTo,
      payment_report: order?.paymentReportId,
      payment_type: 'card',
      imp_uid: response?.imp_uid,
      merchant_uid: response.merchant_uid,
      price: order?.totalPrice,
      status: 'Y'
    }
    const rs = await postPaymentReport(params);
    saveTaxBill()
    getDataList()
    setIsLoading(false)
  }

  const saveTaxBill = async () => {

    const toDate = moment(new Date()).format('YYYYMMDD');
    const mgtKey = toDate + '-' + order?.paymentReportId;

    const fromRs = await getCompanyOrder(order?.companyFrom);
    const fromData = fromRs.data || {}

    const toRs = await getCompanyOrder(order?.companyTo);
    const toData = toRs.data || {}

    const params = {
      payment_report_id : order?.paymentReportId,
      company_from_number : fromData.company_number,
      company_from_name : fromData.name,
      company_from_user_name : fromData.username,
      company_from_address : fromData.address1 + fromData.address2,
      company_from_email : fromData.email,
      company_from_phone : fromData.phone,
      company_from_mobile : fromData.mobile_phone,
      company_from_type : fromData.type,
      company_from_sector : fromData.type,
      company_to_number : toData.company_number,
      company_to_name : toData.name,
      company_to_user_name : toData.username,
      company_to_address : toData.address1 + toData.address2,
      company_to_email : toData.email,
      company_to_phone : toData.phone,
      company_to_mobile : toData.mobile_phone,
      company_to_fax : toData.fax,
      company_to_type : toData.type,
      company_to_sector : toData.type,
      price : parseInt(order?.totalPrice * (10 / 11)),
      vat : order?.totalPrice - parseInt(order?.totalPrice * (10 / 11)),
      total_price : order?.totalPrice,            
      mgt_key : mgtKey,
      mgt_date : toDate,
    }        
    const response = await postTax(params)
    alert(response.data?.msg || '')
  }

  const modalClose = () => {
    setModalShow(false)
  }

  useEffect(() => {
    getDataList()
  }, [page])

  useEffect(()=>{
    payMethod && requestPay()
  }, [payMethod])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <MetaTags>
            <title>청구서 | 웨이스트버스</title>
          </MetaTags>
          <Breadcrumbs
            maintitle="Home"
            title="청구서"
            breadcrumbItem="청구서"
          />
          {data.length > 0 && data.map((item, index) => {
            const prevPrice = item.prev_price || 0;
            const payedPrice = item.payed_price || 0;
            const price = item.total_price || 0;
            const totalPrice = item.total_payment_price || 0;
            const totalQty = item.total_qty_kg;
            const prevDate = item?.report_date ? moment(item.report_date).add(1, 'months').format('YYYY-MM-DD') : this.state.prevDate
            return(
          <Row>
            <Col md="12">
              <table
                className="body-wrap"
                style={{
                  fontFamily: "Helvetica Neue,Helvetica,Arial,sans-serif",
                  boxSizing: "border-box",
                  fontSize: "14px",
                  width: "100%",
                  backgroundColor: "transparent",
                  margin: "0",
                }}
                bgcolor="#f6f6f6"
              >
                <tbody>
                  <tr
                    style={{
                      fontFamily: "Helvetica Neue,Helvetica,Arial,sans-serif",
                      boxSizing: "border-box",
                      fontSize: "14px",
                      margin: "0",
                    }}
                  >
                    <td
                      className="container"
                      width="600"
                      style={{
                        fontFamily:
                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                        boxSizing: "border-box",
                        fontSize: "14px",
                        verticalAlign: "top",
                        display: "block",
                        maxWidth: "600px",
                        clear: "both",
                        margin: "0",
                      }}
                      valign="top"
                    >
                      <div
                        className="content"
                        style={{
                          fontFamily:
                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                          boxSizing: "border-box",
                          fontSize: "14px",
                          maxWidth: "600px",
                          display: "block",
                          margin: "0",
                          padding: "26px 0 0 0",
                        }}
                      >
                        <table
                          className="main"
                          width="100%"
                          cellPadding="0"
                          cellSpacing="0"
                          style={{
                            fontFamily:
                              "Helvetica Neue,Helvetica,Arial,sans-serif",
                            boxSizing: "border-box",
                            fontSize: "14px",
                            borderRadius: "7px",
                            margin: "0",
                            border: "none",
                          }}
                        >
                          <tbody>
                            <tr
                              style={{
                                fontFamily:
                                  "Helvetica Neue,Helvetica,Arial,sans-serif",
                                boxSizing: "border-box",
                                fontSize: "14px",
                                margin: "0",
                              }}
                            >
                              <td
                                className="content-wrap aligncenter"
                                style={{
                                  fontFamily:
                                    "Helvetica Neue,Helvetica,Arial,sans-serif",
                                  boxSizing: "border-box",
                                  fontSize: "14px",
                                  verticalAlign: "top",
                                  margin: "0",
                                  padding: "20px",
                                  //border: "3px solid #1d1e3a",
                                  borderRadius: "7px",
                                  backgroundColor: "#fff",
                                  filter: 'drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.03))'
                                }}
                                align="center"
                                valign="top"
                              >
                                <table
                                  width="100%"
                                  cellPadding="0"
                                  cellSpacing="0"
                                  style={{
                                    fontFamily:
                                      "Helvetica Neue,Helvetica,Arial,sans-serif",
                                    boxSizing: "border-box",
                                    fontSize: "14px",
                                    margin: "0",
                                  }}
                                >
                                  <tbody>
                                    <tr
                                      style={{
                                        fontFamily:
                                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                                        boxSizing: "border-box",
                                        fontSize: "14px",
                                        margin: "0",
                                      }}
                                    >
                                      <td
                                        className="content-block"
                                        style={{
                                          fontFamily:
                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                          boxSizing: "border-box",
                                          fontSize: "14px",
                                          verticalAlign: "top",
                                          margin: "0",
                                          padding: "0 0 20px",
                                        }}
                                        valign="top"
                                      >
                                        <h2
                                          className="aligncenter"
                                          style={{
                                            fontFamily:
                                              "Helvetica Neue,Helvetica,Arial,Lucida Grande,sans-serif",
                                            boxSizing: "border-box",
                                            fontSize: "24px",
                                            color: "#000",
                                            lineHeight: "1.4em",
                                            fontWeight: "400",
                                            textAlign: "center",
                                            margin: "40px 0 0",
                                          }}
                                          align="center"
                                        >
                                          <b style={{ fontWeight: "600" }}>{prevDate}</b> 결제 예정 금액은{" "}
                                          <b style={{ fontWeight: "600", color: '#FF4949' }}>
                                            {" "}
                                            <br />{Util.setCommaPrice(totalPrice)}
                                          </b>
                                          원 입니다.
                                        </h2>
                                      </td>
                                    </tr>
                                    <tr
                                      style={{
                                        fontFamily:
                                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                                        boxSizing: "border-box",
                                        fontSize: "14px",
                                        margin: "0",
                                      }}
                                    >
                                      <td
                                        className="content-block aligncenter"
                                        style={{
                                          fontFamily:
                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                          boxSizing: "border-box",
                                          fontSize: "14px",
                                          verticalAlign: "top",
                                          textAlign: "center",
                                          margin: "0",
                                          padding: "0 0 20px",
                                        }}
                                        align="center"
                                        valign="top"
                                      >
                                        <table
                                          className="invoice"
                                          style={{
                                            fontFamily:
                                              "Helvetica Neue,Helvetica,Arial,sans-serif",
                                            boxSizing: "border-box",
                                            fontSize: "14px",
                                            textAlign: "left",
                                            width: "80%",
                                            margin: "40px auto",
                                          }}
                                        >
                                          <tbody>
                                            <tr
                                              style={{
                                                fontFamily:
                                                  "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                boxSizing: "border-box",
                                                fontSize: "14px",
                                                margin: "0",
                                              }}
                                            >
                                              <td
                                                style={{
                                                  fontFamily:
                                                    "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                  boxSizing: "border-box",
                                                  fontSize: "14px",
                                                  verticalAlign: "top",
                                                  margin: "0",
                                                  padding: "5px 0",
                                                }}
                                                valign="top"
                                              >
                                                <b style={{ fontWeight: "bold" }}>{item?.company_from?.name}</b>
                                                <br/>
                                                <br/>
                                                정산요약
                                              </td>
                                            </tr>
                                            <tr
                                              style={{
                                                fontFamily:
                                                  "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                boxSizing: "border-box",
                                                fontSize: "14px",
                                                margin: "0",
                                              }}
                                            >
                                              <td
                                                style={{
                                                  fontFamily:
                                                    "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                  boxSizing: "border-box",
                                                  fontSize: "14px",
                                                  verticalAlign: "top",
                                                  margin: "0",
                                                  padding: "5px 0",
                                                }}
                                                valign="top"
                                              >
                                                <table
                                                  className="invoice-items"
                                                  cellPadding="0"
                                                  cellSpacing="0"
                                                  style={{
                                                    fontFamily:
                                                      "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                    boxSizing: "border-box",
                                                    fontSize: "14px",
                                                    width: "100%",
                                                    margin: "0",
                                                  }}
                                                >
                                                  <tbody>
                                                  <tr
                                                      style={{
                                                        fontFamily:
                                                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                        boxSizing:
                                                          "border-box",
                                                        fontSize: "14px",
                                                        margin: "0",
                                                      }}
                                                    >
                                                      <td
                                                        style={{
                                                          fontFamily:
                                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                          boxSizing:
                                                            "border-box",
                                                          fontSize: "14px",
                                                          verticalAlign:
                                                            "top",
                                                          borderTopWidth:
                                                            "1px",
                                                          borderTopColor:
                                                            "#eee",
                                                          borderTopStyle:
                                                            "solid",
                                                          margin: "0",
                                                          padding: "5px 0",
                                                        }}
                                                        valign="top"
                                                      >
                                                        총 입고량
                                                      </td>
                                                      <td
                                                        className="alignright"
                                                        style={{
                                                          fontFamily:
                                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                          boxSizing:
                                                            "border-box",
                                                          fontSize: "14px",
                                                          verticalAlign:
                                                            "top",
                                                          textAlign: "right",
                                                          borderTopWidth:
                                                            "1px",
                                                          borderTopColor:
                                                            "#eee",
                                                          borderTopStyle:
                                                            "solid",
                                                          margin: "0",
                                                          padding: "5px 0",
                                                          whiteSpace: 'nowrap'
                                                        }}
                                                        align="right"
                                                        valign="top"
                                                      >
                                                        {Util.setCommaPrice(totalQty)}kg
                                                      </td>
                                                    </tr>
                                                    <tr
                                                      style={{
                                                        fontFamily:
                                                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                        boxSizing:
                                                          "border-box",
                                                        fontSize: "14px",
                                                        margin: "0",
                                                      }}
                                                    >
                                                      <td
                                                        style={{
                                                          fontFamily:
                                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                          boxSizing:
                                                            "border-box",
                                                          fontSize: "14px",
                                                          verticalAlign:
                                                            "top",
                                                          borderTopWidth:
                                                            "1px",
                                                          borderTopColor:
                                                            "#eee",
                                                          borderTopStyle:
                                                            "solid",
                                                          margin: "0",
                                                          padding: "5px 0",
                                                        }}
                                                        valign="top"
                                                      >
                                                        당월 미정산액
                                                      </td>
                                                      <td
                                                        className="alignright"
                                                        style={{
                                                          fontFamily:
                                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                          boxSizing:
                                                            "border-box",
                                                          fontSize: "14px",
                                                          verticalAlign:
                                                            "top",
                                                          textAlign: "right",
                                                          borderTopWidth:
                                                            "1px",
                                                          borderTopColor:
                                                            "#eee",
                                                          borderTopStyle:
                                                            "solid",
                                                          margin: "0",
                                                          padding: "5px 0",
                                                          whiteSpace: 'nowrap'
                                                        }}
                                                        align="right"
                                                        valign="top"
                                                      >
                                                        {Util.setCommaPrice(price)}원
                                                      </td>
                                                    </tr>
                                                    <tr
                                                      style={{
                                                        fontFamily:
                                                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                        boxSizing:
                                                          "border-box",
                                                        fontSize: "14px",
                                                        margin: "0",
                                                      }}
                                                    >
                                                      <td
                                                        style={{
                                                          fontFamily:
                                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                          boxSizing:
                                                            "border-box",
                                                          fontSize: "14px",
                                                          verticalAlign:
                                                            "top",
                                                          borderTopWidth:
                                                            "1px",
                                                          borderTopColor:
                                                            "#eee",
                                                          borderTopStyle:
                                                            "solid",
                                                          margin: "0",
                                                          padding: "5px 0",
                                                        }}
                                                        valign="top"
                                                      >
                                                        이전미정산액
                                                      </td>
                                                      <td
                                                        className="alignright"
                                                        style={{
                                                          fontFamily:
                                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                          boxSizing:
                                                            "border-box",
                                                          fontSize: "14px",
                                                          verticalAlign:
                                                            "top",
                                                          textAlign: "right",
                                                          borderTopWidth:
                                                            "1px",
                                                          borderTopColor:
                                                            "#eee",
                                                          borderTopStyle:
                                                            "solid",
                                                          margin: "0",
                                                          padding: "5px 0",
                                                          whiteSpace: 'nowrap'
                                                        }}
                                                        align="right"
                                                        valign="top"
                                                      >
                                                        {Util.setCommaPrice(prevPrice)}원
                                                      </td>
                                                    </tr>
                                                    <tr
                                                      style={{
                                                        fontFamily:
                                                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                        boxSizing:
                                                          "border-box",
                                                        fontSize: "14px",
                                                        margin: "0",
                                                      }}
                                                    >
                                                    </tr>
                                                    <tr
                                                      className="total"
                                                      style={{
                                                        fontFamily:
                                                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                        boxSizing:
                                                          "border-box",
                                                        fontSize: "14px",
                                                        margin: "0",
                                                      }}
                                                    >
                                                      <td
                                                        className="alignright"
                                                        width="80%"
                                                        style={{
                                                          fontFamily:
                                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                          boxSizing:
                                                            "border-box",
                                                          fontSize: "14px",
                                                          verticalAlign:
                                                            "top",
                                                          textAlign: "right",
                                                          borderTopWidth:
                                                            "2px",
                                                          borderTopColor:
                                                            "#333",
                                                          borderTopStyle:
                                                            "solid",
                                                          borderBottomColor:
                                                            "#333",
                                                          borderBottomWidth:
                                                            "2px",
                                                          borderBottomStyle:
                                                            "solid",
                                                          fontWeight: "700",
                                                          margin: "0",
                                                          padding: "5px 0",
                                                        }}
                                                        align="right"
                                                        valign="top"
                                                      >
                                                        합계
                                                      </td>
                                                      <td
                                                        className="alignright"
                                                        style={{
                                                          fontFamily:
                                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                          boxSizing:
                                                            "border-box",
                                                          fontSize: "14px",
                                                          verticalAlign:
                                                            "top",
                                                          textAlign: "right",
                                                          borderTopWidth:
                                                            "2px",
                                                          borderTopColor:
                                                            "#333",
                                                          borderTopStyle:
                                                            "solid",
                                                          borderBottomColor:
                                                            "#333",
                                                          borderBottomWidth:
                                                            "2px",
                                                          borderBottomStyle:
                                                            "solid",
                                                          fontWeight: "700",
                                                          margin: "0",
                                                          padding: "5px 0",
                                                          whiteSpace: 'nowrap'
                                                        }}
                                                        align="right"
                                                        valign="top"
                                                      >
                                                        {Util.setCommaPrice(totalPrice)}원
                                                      </td>
                                                    </tr>
                                                    <tr
                                                      className="total"
                                                      style={{
                                                        fontFamily:
                                                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                        boxSizing:
                                                          "border-box",
                                                        fontSize: "14px",
                                                        margin: "0",
                                                      }}
                                                    >
                                                      <td
                                                        className="alignright"
                                                        width="80%"
                                                        style={{
                                                          fontFamily:
                                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                          boxSizing:
                                                            "border-box",
                                                          fontSize: "14px",
                                                          verticalAlign:
                                                            "top",
                                                          textAlign: "right",
                                                          borderTopWidth:
                                                            "2px",
                                                          borderTopColor:
                                                            "#333",
                                                          borderTopStyle:
                                                            "solid",
                                                          borderBottomColor:
                                                            "#333",
                                                          borderBottomWidth:
                                                            "2px",
                                                          borderBottomStyle:
                                                            "solid",
                                                          fontWeight: "700",
                                                          margin: "0",
                                                          padding: "5px 0",
                                                        }}
                                                        align="right"
                                                        valign="top"
                                                      >
                                                        결제한 금액
                                                      </td>
                                                      <td
                                                        className="alignright"
                                                        style={{
                                                          fontFamily:
                                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                                          boxSizing:
                                                            "border-box",
                                                          fontSize: "14px",
                                                          verticalAlign:
                                                            "top",
                                                          textAlign: "right",
                                                          borderTopWidth:
                                                            "2px",
                                                          borderTopColor:
                                                            "#333",
                                                          borderTopStyle:
                                                            "solid",
                                                          borderBottomColor:
                                                            "#333",
                                                          borderBottomWidth:
                                                            "2px",
                                                          borderBottomStyle:
                                                            "solid",
                                                          fontWeight: "700",
                                                          margin: "0",
                                                          padding: "5px 0",
                                                          color: 'blue',
                                                          whiteSpace: 'nowrap'
                                                        }}
                                                        align="right"
                                                        valign="top"
                                                      >
                                                        {Util.setCommaPrice(payedPrice)}원
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        {item?.state !== 'Y' && totalPrice > 0 ?
                                          <button className="btn btn-primary w-md waves-effect waves-light" type="submit" onClick={() => {
                                            setModalShow(true)
                                            setSelectedData(item)
                                          }}>정산하기(즉시결제)
                                          </button>
                                          :
                                          <div style={{ cursor: 'auto', fontSize: 16, fontWeight: "bold", color: '#C9CACA' }}>
                                            { totalPrice > 0 ? '결제가 완료되었습니다.' : '결제하실 금액이 없습니다.'}
                                          </div>
                                        }
                                      </td>
                                    </tr>
                                    <tr>
                                      <td style={{textAlign: "center", fontSize: 16, fontWeight: "bold", color: 'black'}}>
                                        <p style={{cursor: "pointer"}} onClick={()=>{
                                          history.push('settlement-details')
                                        }}>정산 내역 / 고지 내역</p>
                                      </td>
                                    </tr>
                                    <tr
                                      style={{
                                        fontFamily:
                                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                                        boxSizing: "border-box",
                                        fontSize: "14px",
                                        margin: "0",
                                      }}
                                    >
                                      <td
                                        className="content-block aligncenter"
                                        style={{
                                          fontFamily:
                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                          boxSizing: "border-box",
                                          fontSize: "14px",
                                          verticalAlign: "top",
                                          textAlign: "center",
                                          margin: " 0",
                                          padding: " 0 0 20px",
                                        }}
                                        align="center"
                                        valign="top"
                                      >

                                      </td>
                                    </tr>

                                    <tr
                                      style={{
                                        fontFamily:
                                          "Helvetica Neue,Helvetica,Arial,sans-serif",
                                        boxSizing: "border-box",
                                        fontSize: "14px",
                                        margin: "0",
                                      }}
                                    >
                                      <td
                                        className="content-block"
                                        style={{
                                          textAlign: "center",
                                          fontFamily:
                                            "Helvetica Neue,Helvetica,Arial,sans-serif",
                                          boxSizing: "border-box",
                                          fontSize: "14px",
                                          verticalAlign: "top",
                                          margin: "0",
                                          padding: "0",
                                        }}
                                        valign="top"
                                      >
                                        © {new Date().getFullYear()} Wasteverse
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>
          )})}
        </Container>
      </div>
      {modalSuccess && 
      <div style={{
        position: "fixed",
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        background: 'rgba(0, 0, 0, 0.4)',
        zIndex: 999,
        display: "flex",
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <div style={{width: 480, height: 300, backgroundColor: "#fff", zIndex: 1000, padding: 36}}>
          <div style={{display: "flex", justifyContent: "space-between"}}>
            <p style={{fontSize: 20, color: 'black', fontWeight: 'bold'}}>결제완료</p>
            <p style={{cursor: "pointer", fontSize: 20}} onClick={()=>{
              setModalSuccess(false)
            }}>X</p>
          </div>
          <div style={{padding: 12}}>
            <div style={{display: "flex", justifyContent: "space-between"}}>
              <p style={{fontSize: 16}}>주문번호</p>
              <p style={{fontSize: 16, color: 'black', fontWeight: 'bold'}}>{rsp.merchant_uid?.split('_')?.[1]}</p>
            </div>
            <div style={{display: "flex", justifyContent: "space-between", marginTop: 24}}>
              <p style={{fontSize: 16, color: 'black', fontWeight: 'bold'}}>{order.prevMonth + '월분 ' + Util.setCommaPrice(order.totalPrice) + '원 결제가 완료되었습니다.'}</p>
            </div>
          </div>
        </div>
      </div>
      }
      <Modal title={'결제수단 선택'} show={modalShow} onHide={modalClose} size="md">
        <div style={{ zIndex: 1, minHeight : '300px' }}>
            <div className="position-relative app-search d-none d-lg-block" style={{ padding: 0, width: 330, marginBottom : "1rem" }}>
            </div>                          
            <div style={{ position: "relative", minHeight : '300px', overflowY: "auto" }}>
              <div style={{position: "absolute", minHeight : '300px', right: 0, left: 0, overflowX: "hidden"}}>
                {payMethodArr && payMethodArr.map((item) => {
                  return (
                    <div style={isHover == item.key ? { ...style, ...hoverStyle } : { ...style }} key={item.key}
                      onMouseOver={() => {
                        setIsHover(item.key)
                      }}
                      onMouseLeave={() => {
                        setIsHover(false)
                      }}
                      onClick={() => {
                        const totalPrice = selectedData.total_payment_price || 0;
                        const totalQty = selectedData.total_qty_kg;
                        setPayMethod(item.key)
                        modalClose()
                        setOrder({
                          price : data?.price,
                          vat : data?.vat,
                          totalSum: totalQty,
                          totalPrice: totalPrice,
                          prevMonth: prevMonth,
                          companyFrom: data?.company_from,
                          companyTo: data?.company_to,
                          paymentReportId: data?.id
                        })
                      }}>{item.text}
                    </div>
                  )
                })}
              </div>
            </div>                          
        </div>
      </Modal>
      {isLoading && <div style={{
        position: "absolute",
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        background: 'rgba(255, 255, 255, 0.6)',
        zIndex: 999,
        display: "flex",
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <img src={loading} alt="로딩중입니다." width={'5%'}></img>
      </div>}
    </React.Fragment>
  )
}

export default EmitterBill;
